/**
 * Pillarbox Background — fills the black bars on desktop/landscape screens.
 *
 * Two modes (toggle via PILLARBOX_MODE below):
 *   "stripe"  — Prismara rainbow stripe, darkened (default)
 *   "region"  — blurred, darkened region art that changes per-scene
 *
 * On portrait/mobile the CSS hides the element entirely (no GPU cost).
 */

// ── Mode switch ────────────────────────────────────────────────────────────
const PILLARBOX_MODE = "stripe"; // "stripe" | "region"

// ── Stripe asset ───────────────────────────────────────────────────────────
import bgStripe from "../assets/beams/primara_enchantmentsstripe.png";

// ── Region background images (same assets LevelScene uses) ─────────────────
import bgMain      from "../assets/backgrounds/main_screen_background.png";
import bgIgnarion  from "../assets/backgrounds/pazzurumon_ignarion.png";
import bgHydrallis from "../assets/backgrounds/pazzurumon_hydrallys.png";
import bgTerraevel from "../assets/backgrounds/pazzurumon_terravael.png";
import bgVoltrix   from "../assets/backgrounds/pazzurumon_voltaris.png";
import bgAetherion from "../assets/backgrounds/pazzurumon_aetherion.png";

const REGION_BG = {
  volcano: bgIgnarion,
  ocean:   bgHydrallis,
  earth:   bgTerraevel,
  storm:   bgVoltrix,
  psychic: bgAetherion,
};

const TITLE_SCENES = new Set([
  "BootScene", "TitleScene", "MapScene", "CollectionScene",
  "BestiaryScene", "CreditsScene", "LeaderboardScene",
  "StoreScene", "OptionsScene",
]);

let _el = null;
let _current = null;

function _setBg(url) {
  if (!_el || url === _current) return;
  _current = url;
  _el.style.backgroundImage = `url(${url})`;
}

function _applyStripeStyle() {
  _el.style.filter = "brightness(0.25)";
  _el.style.backgroundSize = "auto 100%";
  _el.style.backgroundRepeat = "repeat-x";
  _el.style.backgroundPosition = "center";
}

function _applyRegionStyle() {
  _el.style.filter = "blur(12px) brightness(0.25)";
  _el.style.backgroundSize = "cover";
  _el.style.backgroundRepeat = "no-repeat";
  _el.style.backgroundPosition = "center";
}

/**
 * Initialise the pillarbox system. Call once after `new Phaser.Game(config)`.
 */
export function initPillarbox(game) {
  _el = document.getElementById("pillarbox-bg");
  if (!_el) return;

  if (PILLARBOX_MODE === "stripe") {
    _applyStripeStyle();
    _setBg(bgStripe);
    // Stripe mode is static — no scene listener needed
    return;
  }

  // Region mode — blurred art that changes per scene
  _applyRegionStyle();
  _setBg(bgMain);

  game.events.on("step", () => {
    const active = game.scene.getScenes(true);
    if (!active.length) return;

    const top = active[active.length - 1];
    const key = top.sys.settings.key;

    if (key === "LevelScene" && top.regionId) {
      _setBg(REGION_BG[top.regionId] || bgMain);
    } else if (TITLE_SCENES.has(key)) {
      _setBg(bgMain);
    }
  });
}
